import { css } from "../../../component-styles";

/** No color overrides — inherits from the page's global CSS. */
export const none = css``;
